import React from 'react';
import { Text } from '../../../../../../ui/atoms/Text/Text';
import { Button } from '../../../../../../ui/atoms/Button/Button';
import { SUPPORT_COPY } from '../../../../constants/support';
import './LateReplyPromptStyles.scss';
const BASE_CLASS = 'ai-late-reply-prompt';
/**
 * Shown right under the latest support message when the agent replied AFTER the customer ended
 * the chat. Nothing happens until the customer chooses: "Continue chat" asks the server to bring
 * the same request back to the queue; "Not now" leaves the composer with IPA.
 *
 * When the support side has since closed the request, it says so and tells the customer how to
 * start a new one. Offers are minted by the server, so the widget cannot start a chat itself.
 */
export function LateReplyPrompt({ closed = false, isWorking = false, onContinue, onDismiss }) {
    return (React.createElement("div", { className: `${BASE_CLASS}${closed ? ` ${BASE_CLASS}--closed` : ''}`, role: "status" },
        React.createElement("i", { className: `${BASE_CLASS}__icon ${closed ? 'fa-light fa-circle-info' : 'fa-light fa-comment-dots'}`, "aria-hidden": "true" }),
        React.createElement("div", { className: `${BASE_CLASS}__text` },
            React.createElement(Text, { variant: "x-small" }, closed ? SUPPORT_COPY.LATE_REPLY_CLOSED : SUPPORT_COPY.LATE_REPLY_TEXT),
            closed && (React.createElement(Text, { variant: "xx-small", className: `${BASE_CLASS}__hint` }, SUPPORT_COPY.LATE_REPLY_CLOSED_HINT))),
        React.createElement("div", { className: `${BASE_CLASS}__actions` },
            !closed && (React.createElement(Button, { variant: "primary", disabled: isWorking, onClick: onContinue }, SUPPORT_COPY.LATE_REPLY_CONTINUE)),
            React.createElement(Button, { disabled: isWorking, onClick: onDismiss }, closed ? SUPPORT_COPY.LATE_REPLY_CLOSED_DISMISS : SUPPORT_COPY.LATE_REPLY_DISMISS))));
}
